var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./rtLabelItem.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5dce6718\"}!../../../../vue-loader/lib/selector?type=template&index=0!./rtLabelItem.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/label/rtLabelItem.vue
// module id = 1400
// module chunks = 91